var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.discount.product_reduce.length
  var m0 = _vm.discount.give_points > 0 ? _vm.points_name() : null
  var m1 = _vm.discount.give_points > 0 ? _vm.points_name() : null
  var m2 = _vm.discount.give_points > 0 ? _vm.points_name() : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        m0: m0,
        m1: m1,
        m2: m2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }